import { Entity } from '@marmon/shared/types/common';

/**
 * Reason for sort mod is that Taiga components like to use numbers to illustrate
 * sort direction, hence sortMod, whereas Algolia needs the explicit naming of the
 * sort direction, hence sortDir.
 */
export type SortMod = 1 | -1;
export type SortDir = 'asc' | 'desc';
export const SortDirMap = new Map<SortMod, SortDir>([
	[1, 'asc'],
	[-1, 'desc'],
]);

export type SortItem<T extends Entity> = {
	label: string;
	key: keyof T;
	sortDir: SortDir;
};

type SortConfigBase<T extends Entity> = {
	enabled: boolean;
	key?: keyof T | never;
};

interface SortConfigDisabled<T extends Entity> extends SortConfigBase<T> {
	enabled: false;
	key?: never;
}

interface SortConfigEnabled<T extends Entity> extends SortConfigBase<T> {
	enabled: true;
	key: keyof T;
}

export type SortConfig<T extends Entity> =
	| SortConfigDisabled<T>
	| SortConfigEnabled<T>;
